import { articles, findArticle, searchArticles, type HelpContext } from './articles';
import './help.css';
export function HelpContent({selected,query,context,choose,onBack}:{selected?:string;query:string;context?:HelpContext;choose:(id:string)=>void;onBack:()=>void}) {
  const article=selected?findArticle(selected):undefined;
  const results=searchArticles(query);
  return (
      <div className="help-body">
        {article && !query.trim() ? <article>
          <button className="help-link" onClick={() => onBack()}>← All topics</button>
          <p className="help-section">{article.section}</p><h3>{article.title}</h3>
          <p>{article.summary}</p>
          {article.use && <><h4>How to use</h4><p>{article.use}</p></>}
          {article.steps && <ol>{article.steps.map(step => <li key={step}>{step}</li>)}</ol>}
          {article.outcome && <><h4>What you get</h4><p>{article.outcome}</p></>}
          {context?.description && <div className="help-context"><h4>{context.title || 'In this flow'}</h4><p>{context.description}</p></div>}
          <h4>Related topics</h4><div className="help-related">{article.related.map(id => <button key={id} className="help-link" onClick={() => choose(id)}>{findArticle(id)?.title}</button>)}</div>
        </article> : <>
          <p className="help-intro">Quick answers about Nodes and how to get things done.</p>
          {results.length === 0 && <p role="status">No results. Try “flow”, “inputs”, or “results”.</p>}
          {(['Guides', 'Concepts', 'Actions'] as const).map(section => {
            const rows = (query.trim() ? results : articles).filter(item => item.section === section);
            return rows.length > 0 && <section key={section}><h3>{section}</h3>{rows.map(item => <button key={item.id} className="help-result" onClick={() => choose(item.id)}><strong>{item.title}</strong><span>{item.summary}</span></button>)}</section>;
          })}
        </>}
      </div>
  );
}
